<template>
    <div class="panel">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">
					<div class="row">
							<div class="col-sm-6">
							    <div class="form-group">
							        <label class="col-sm-3 control-label">培训项目名称</label>
							        <div class="col-sm-9">
							            <input type="text" v-model="query.pxztWord" name="pxztWord" class="form-control" >
							        </div>
							    </div>
							</div>
							<div class="col-sm-6">
							    <div class="form-group">
							        <label class="col-sm-3 control-label">项目类型</label>
							        <div class="col-sm-9">
										<treeselect placeholder="-项目类型筛选-" v-model="query.lxId" :multiple="false" :options="lxList" noChildrenText="无子类型" style="height: 31px;"/>
							        </div>
							    </div>
							</div>
					</div>
                  
				  <div class="row">
					  <div class="col-sm-6">
					      <div class="form-group">
					          <label class="col-sm-3 control-label">状态</label>
					          <div class="col-sm-9">
					              <select name="zt" class="form-control" v-model="query.zt" >
					                  <option value="">-请选择-</option>
					                  <option value="OK">启用</option>
					                  <option value="BLOCK">禁用</option>
					              </select>
					          </div>
					      </div>
					  </div>
					  <div class="col-sm-6">
					      <div class="pull-right">
					          <button @click="search()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-search" aria-hidden="true"></i>查询</button>
					          <button @click="addOrg()" type="button" class="btn btn-primary btn-sm"><i class="fa fa-plus" aria-hidden="true"></i>新增培训项目</button>
					      </div>
					  </div>
				</div>
                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
									@onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
		<TrainingBatchConfigDetail ref="TrainingBatchConfigDetail"></TrainingBatchConfigDetail>
    </div>
</template>
<script>
    /**
     * 培训项目管理
     */

    import tableMixin from '@/mixins/table.js';
    import TrainingBatchConfigAdd from './TrainingBatchConfigAdd.vue';//新增
    import TrainingBatchConfigEdit from './TrainingBatchConfigEdit.vue';//修改
    import TrainingBatchConfigDetail from './TrainingBatchConfigDetail.vue';//详情
    export default {
        mixins: [tableMixin],
        name:"TrainingBatchConfigList",
		components: { TrainingBatchConfigDetail },
        data:function(){
            return {
				lxList:[],
                query:{
                    xmbh: '',
                    pxztWord: '',
					lxId:null,
                    zt: '',
                },
                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
					{
					    field: 'pxzt',
					    title: '培训项目',
						formatter: (value, row) => {
							return value + '<br>(编号：' + row.xmbh+')';
						}
					},
					{
                        field: 'lxmc',
                        title: '项目类型'
                    },
					{
                        field: 'pxdx',
                        title: '培训对象'
                    },
					{
					    field: 'bmsj',
					    title: '报名时间',
						formatter: (value, row) => {
						    return row.jtbmkssj + "<br/>" + row.jtbmjssj;
						}
					},
                    {
                        field: 'zt',
                        title: '状态',
                        formatter: (value) => {
                            return value == 'OK' ? '启用' : '禁用';
                        }
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            let btnName=row.zt== 'OK' ? '禁用' :'启用';
                            return this.vueFormatter({
                                template: '<div class="operation_column">' +
                                    '<a @click="edit(row)">修改</a> | ' +
                                    '<a @click="qtit(row)">'+btnName+'</a> | ' +
                                    '<a @click="details(row)">详情</a></div>',
                                data: { row },
                                methods: {
                                    edit: this.edit,
                                    qtit:this.qtit,
                                    details:this.details,
                                }
                            })
                        }
                    }
                ]
            }
        },
		  mounted(){
			this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
			this.load();
		  },
		  beforeRouteUpdate(to, from, next){
			this.query = Object.assign(this.query,{current:1,size:10},to.query);
			this.load();
			next();
		  },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'职业培训'},{name:'在线培训'},{name:'培训计划'},{name:'培训项目管理'}]);
			this.$http.post('/htgl/biz/pxjh/pc/getLxTree').then(res=>{
			   if(res.data){
				   this.lxList = res.data;
			   }
			});
		},
        methods: {
            //新增培训批次
            addOrg:function(){
				this.$router.push({name:'TrainingBatchConfigAdd'});
            },
            //修改
            edit:function (row) {
               this.$router.push({name:'TrainingBatchConfigEdit',query:{id:row.id}});
            },
            //详情
            details:function (row) {
				this.$refs.TrainingBatchConfigDetail.open({ id:row.id});
            },
            //启用/禁用提示
            qtit:function (row) {
                let id= row.id;
                let zt = row.zt=='OK' ? 'BLOCK' : 'OK';
				this.$confirm('确定执行此操作吗',()=>{
					this.$http.post("/htgl/biz/pxjh/pc/zt",{id:id, zt:zt}).then((res)=>{
					    if(res.data==true){
							this.$success('操作成功',()=>{
								  this.load();//刷新列表
							})
					    }
					});
				})
            },

            //根据查询条件进行检索
            search:function(){
				//将数据表格的页码以及每一页展示的数据重置为1，10
				let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
				this.$router.push({name:this.$route.name,query:query});
            },
            load:function(pageNumber, pageSize){
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/biz/pxjh/pc/fycx',this.query).then(res=>{
                    console.log(res.data)
                    let data = res.data;
                    //封装返回值
                    let result= {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
					this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
						pageSize:parseInt(this.query.size)});
                });
            },
            pageChange:function(pageNumber, pageSize){
               let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
               this.$router.push({name:this.$route.name,query:query});
            }
        }
    }
</script>
<style scoped>

</style>
